"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickSearchViewPanelControl = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const QuickSearchInput_1 = require("./QuickSearchInput");
const QuickSearchViewPanelControl = (props) => {
    let elementType = props.viewType === 'ToolPanel' ? 'DashboardToolbar' : 'ToolPanel';
    return React.createElement(QuickSearchInput_1.QuickSearchInput, { className: `ab-${elementType}__QuickSearch__text`, width: '15rem' });
};
exports.QuickSearchViewPanelControl = QuickSearchViewPanelControl;
